(function (window, document) {
  'use strict';
  if (window.__gbgear) return;
  window.__gbgear = 2;
  var cart = null, desired = {}, versions = {}, running = {}, touch = null, dragged = null, booted = false;
  function cards() { return document.querySelectorAll('[data-gbgear] [data-gbit]'); }
  function linesFor(id) {
    return ((cart && cart.items) || []).filter(function (line) {
      return String(line.variant_id) === id && line.quantity > 0 && !Object.keys(line.properties || {}).length;
    });
  }
  function paint() {
    cards().forEach(function (card) {
      var id = String(card.dataset.id), wanted = Object.prototype.hasOwnProperty.call(desired, id) ? desired[id] : linesFor(id).length > 0;
      if (card.classList.contains('on') !== wanted) card.classList.toggle('on', wanted);
      card.setAttribute('role', 'button');
      card.tabIndex = 0;
      card.setAttribute('aria-pressed', String(wanted));
      card.setAttribute('aria-busy', String(!!running[id]));
      var mark = card.querySelector('.gk');
      var markText = running[id] ? '…' : '✓';
      if (mark && mark.textContent !== markText) mark.textContent = markText;
      // Accessible name = the card's visible text (label-in-name); only the in-flight state appends a hint.
      if (running[id]) card.setAttribute('aria-label', (card.innerText || card.textContent || '').replace(/\s+/g, ' ').trim() + ' — Updating cart');
      else if (card.hasAttribute('aria-label')) card.removeAttribute('aria-label');
    });
  }
  function showError(id, message) {
    cards().forEach(function (card) {
      if (String(card.dataset.id) !== id) return;
      var widget = card.closest('[data-gbgear]');
      var error = widget.querySelector('[data-gbgear-error]');
      if (!error && message) {
        error = document.createElement('p'); error.setAttribute('data-gbgear-error', '');
        error.setAttribute('role', 'alert'); widget.appendChild(error);
      }
      if (error) { error.textContent = message || ''; error.hidden = !message; }
    });
  }
  function pump(id) {
    if (running[id]) return;
    running[id] = true; paint();
    var api = window.GBCart;
    api.queueMutation(async function () {
      cart = await api.readCart();
      var verified = false;
      while (Object.prototype.hasOwnProperty.call(desired, id)) {
        var wanted = desired[id], version = versions[id], existing = linesFor(id);
        if (wanted === (existing.length > 0)) {
          // A click must not silently stop on a cached snapshot. Another cart
          // control or tab may have changed the server since that snapshot.
          if (!verified) { cart = await api.readCart(true); verified = true; continue; }
          delete desired[id]; break;
        }
        try {
        var updates = {}, payload, url;
        if (wanted) {
          // Adding an unmarked accessory must never change a protected gift
          // that happens to use the same variant.
          payload = { items: [{ id: Number(id), quantity: 1 }] };
          url = '/cart/add.js?kaching_bundles=true';
        } else {
          existing.forEach(function (line) { updates[line.key] = 0; });
          payload = existing.length === 1 ? { id: existing[0].key, quantity: 0 } : { updates: updates };
          url = existing.length === 1 ? '/cart/change.js?kaching_bundles=true' : '/cart/update.js?kaching_bundles=true';
        }
        payload.sections = ['cart-drawer', 'cart-icon-bubble']; payload.sections_url = window.location.pathname;
        var response = await window.fetch(url, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!response.ok) throw new Error('Cart update failed (' + response.status + ')');
        var fresh = await response.json();
        var rendered = fresh.sections && api.applyDrawer(fresh.sections);
        cart = Array.isArray(fresh.items) && typeof fresh.total_price === 'number' ? fresh : await api.readCart(!rendered);
        if (wanted !== (linesFor(id).length > 0)) throw new Error('Option update not confirmed');
        api.commitCart(cart, true);
        verified = true;
        } catch (error) {
          var readConfirmed = false;
          try { cart = await api.readCart(true); readConfirmed = true; } catch (readError) {}
          if (readConfirmed && desired[id] === (linesFor(id).length > 0)) { verified = true; continue; }
          if (version !== versions[id]) continue;
          throw error;
        }
      }
    }).catch(function (error) {
      delete desired[id];
      showError(id, 'Could not update this option. Please tap again.');
      console.warn('[GBGear]', error.message);
    }).finally(function () { running[id] = false; paint(); });
  }
  document.addEventListener('touchstart', function (event) {
    var card = event.target.closest && event.target.closest('[data-gbit]');
    var point = event.touches && event.touches[0];
    dragged = null;
    touch = card && point ? { card: card, x: point.clientX, y: point.clientY } : null;
  }, { passive: true, capture: true });
  document.addEventListener('touchmove', function (event) {
    var point = event.touches && event.touches[0];
    if (touch && point && (Math.abs(point.clientX - touch.x) > 8 || Math.abs(point.clientY - touch.y) > 8)) dragged = touch.card;
  }, { passive: true, capture: true });
  document.addEventListener('click', function (event) {
    var card = event.target.closest && event.target.closest('[data-gbgear] [data-gbit]');
    if (!card) return;
    if (card === dragged) { dragged = null; return; }
    if (!window.GBCart || !window.GBCart.queueMutation) return;
    var id = String(card.dataset.id);
    versions[id] = (versions[id] || 0) + 1;
    desired[id] = !card.classList.contains('on');
    showError(id, ''); paint(); pump(id);
  });
  document.addEventListener('keydown', function (event) {
    if (event.repeat || (event.key !== 'Enter' && event.key !== ' ')) return;
    var card = event.target.closest && event.target.closest('[data-gbgear] [data-gbit]');
    if (!card) return;
    event.preventDefault(); card.click();
  });
  function boot() {
    if (booted || !window.GBCart || !window.GBCart.readCart) return;
    booted = true;
    var style = document.createElement('style');
    style.textContent = '.gbgear .git[aria-busy="true"]{cursor:progress}.gbgear .git[aria-busy="true"] .gk{color:#0354d1;background:#fff;border-color:#0354d1}';
    document.head.appendChild(style);
    window.GBCart.subscribe(function (fresh) { cart = fresh; paint(); });
    window.GBCart.readCart().then(function (fresh) { cart = fresh; paint(); }).catch(function () {});
    document.querySelectorAll('[data-gbgear]').forEach(function (widget) {
      var row = widget.querySelector('[data-gbrow]'), dots = widget.querySelector('[data-gdots]');
      if (!row || !dots) return;
      function renderDots() {
        var count = Math.max(1, Math.ceil(row.scrollWidth / Math.max(1, row.clientWidth)));
        dots.hidden = count < 2;
        if (dots.hidden) return;
        if (dots.children.length !== count) {
          dots.replaceChildren();
          for (var i = 0; i < count; i++) dots.appendChild(document.createElement('i'));
        }
        var max = row.scrollWidth - row.clientWidth;
        var selected = max > 0 ? Math.min(count - 1, Math.round(row.scrollLeft / max * (count - 1))) : 0;
        Array.from(dots.children).forEach(function (dot, index) { dot.classList.toggle('on', index === selected); });
      }
      row.addEventListener('scroll', renderDots, { passive: true });
      window.addEventListener('resize', renderDots, { passive: true });
      renderDots();
    });
  }
  document.addEventListener('gb:cart-ready', boot, { once: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
})(window, document);
